export default __webpack_public_path__ + "static/media/agent_profile_icon.94a6c234.svg";